import './footer-b.scss';
import { execOnLoad } from '@general/helpers';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initFooterB = (context) => {
  const sectionContainer = context.classList.contains('shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const newsletterTrigger = document.getElementById('footerNewsletterSubmit');
  const newsletterInput = document.getElementById('footer-b__newsletter-email');
  const newsletterPrivacy = document.getElementById('FooterNlId');

  if (newsletterInput && newsletterTrigger) {
    newsletterInput.addEventListener('input', () => {
      if (newsletterInput.value.trim() !== '') {
        newsletterTrigger.classList.remove('disabled');
      } else {
        newsletterTrigger.classList.add('disabled');
      }
    });

    newsletterTrigger.addEventListener('click', () => {
      const emailValue = newsletterInput.value;
      const privacyChecked = newsletterPrivacy ? newsletterPrivacy.checked : false;

      setTimeout(() => {
        const popupEmail = document.getElementById('NewsletterEmail');
        const popupPrivacy = document.getElementById('NewsletterPrivacy');
        if (popupEmail) popupEmail.value = emailValue;
        if (popupPrivacy) popupPrivacy.checked = privacyChecked;
      }, 300);
    });
  }
};

execOnLoad(window.dAgency.initFooterB, '.footer-b__background');
